// PlayFirst Parent — soft pastel design system tokens used across all
// /parent-app screens. Imported once in PFP screens to avoid utility class
// drift. Tailwind handles the actual styling — these are aliases for the
// long Tailwind strings the design uses repeatedly.
export const PFP = {
  // page wrapper background — warm cream with a soft lavender wash
  page: 'min-h-screen bg-[linear-gradient(180deg,#FFF9F2_0%,#FBF4F9_100%)]',
  card: 'bg-white/85 backdrop-blur-md border border-white shadow-[0_8px_32px_rgba(124,111,156,0.08)] rounded-3xl',
  cardHover: 'hover:shadow-[0_12px_40px_rgba(124,111,156,0.14)] transition-shadow',
  // primary button — deep lavender that reads on cream
  btnPrimary:
    'bg-[#7C6F9C] hover:bg-[#6B5E8A] text-white rounded-full px-6 py-3 font-medium shadow-md shadow-[#7C6F9C]/20 transition-all',
  btnGhost: 'text-[#7C6F9C] hover:bg-[#7C6F9C]/10 rounded-full px-5 py-2.5 transition-colors',
  // soft pastel chip used in onboarding multi-selects
  chip:
    'inline-flex items-center px-4 py-2 rounded-full border-2 text-sm transition-all cursor-pointer select-none',
  chipIdle:
    'border-stone-200 bg-white text-stone-700 hover:border-[#7C6F9C]/40 hover:bg-[#7C6F9C]/5',
  chipActive:
    'border-[#7C6F9C] bg-[#7C6F9C]/10 text-[#5b4f7a] font-medium',
  // headings
  h1: 'text-3xl md:text-5xl font-serif text-[#3a2f4f] leading-tight',
  h2: 'text-2xl md:text-3xl font-serif text-[#3a2f4f]',
  // friendly subtext
  sub: 'text-base md:text-lg text-stone-600 leading-relaxed',
};

export const PFP_ACCENT = '#7C6F9C';
